import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: -5rem;

  div {
    background: var(--shape);
    padding: 1.5px 2rem;
    border-radius: 0.25rem;
    color: var(--text-tittle);

    strong {
      display: block;
      margin-top: 1rem;
      font-size: 2rem;
      font-weight: 500;
      line-height: 3rem;
    };
    header {
      display: flex;
      align-items: center;  
      justify-content: space-between;
    };
    &.background {
      background: var(--green)
    }
  }
`